export default "__VITE_ASSET__CPGFicCN__"